export enum PhaseType {
    Ideas = 1,
    Plot = 2,
    Ready = 3
}

export const PhaseTypeDescriptions = {
    [PhaseType.Ideas]: 'Pick or create Ideas',
    [PhaseType.Plot]: 'Story details',
    [PhaseType.Ready]: 'Generate'
} as const; 